import Dashboard from "../Pages/Dashboard/Dashboard";
import ProjectList from "../Pages/Masters/ProjectList";
import ProjectProfile from "../Pages/Masters/ProjectProfile";
import ManageDocument from '../Components/ManageProject/Document'
import ManageContractorList from "../Components/ManageProject/ContractorList"
import ManageConsultantList from "../Components/ManageProject/ConsultantList"
import ManageGallery from "../Components/ManageProject/Gallery"
import ItemList from "../Pages/Masters/ItemList";
import AccountInformation from "../Pages/AccountInformation";

// routes.js
const routes = [
  ////////////////////// Dashboard Routing ///////////////////////////
  { path: "/", element: <Dashboard /> },
  { path: "/AccountInformation", element: <AccountInformation /> },

  ////////////////////// Master's Routing ///////////////////////////
  { path: "/ProjectList/:project_status?", element: <ProjectList /> },

  ////////////////////// Master's Products Start ///////////////////////////
  { path: "/ProjectProfile/:project_id?", element: <ProjectProfile /> },
  { path: "/Documents/:project_id?", element: <ManageDocument /> },
  { path: "/ContractorList/:project_id?", element: <ManageContractorList /> },
  { path: "/ConsultantList/:project_id?", element: <ManageConsultantList /> },
  { path: "/Gallery/:project_id?", element: <ManageGallery /> },


  // Item List 
  { path: "/ItemList/:project_id", element: <ItemList /> },


];

export default routes;
